import styled, { css } from 'styled-components';
import { hideScrollbar } from '@stylesheets/helpers';
import { duration } from '@stylesheets/motion';
import { APPS_PHONE_MEDIA } from '../../pages/Apps/apps.constants';
import { TILE_GAP_PX } from './AppsFooter.constants';

export const RowRoot = styled.div`
  position: relative;
  min-width: 0;
`;

const list = css`
  display: flex;
  gap: ${TILE_GAP_PX}px;
  margin: 0;
  /* Room for the tiles' focus rings. */
  padding: 2px;
  list-style: none;
`;

export const RowList = styled.ul`
  ${list}
  overflow: auto hidden;
  scroll-snap-type: x proximity;
  overscroll-behavior-x: contain;
  ${hideScrollbar}

  @media (prefers-reduced-motion: no-preference) {
    scroll-behavior: smooth;
  }

  & > li {
    flex: none;
    scroll-snap-align: start;
  }
`;

export const RowGrid = styled.ul`
  ${list}
  flex-wrap: wrap;

  ${APPS_PHONE_MEDIA} {
    justify-content: center;
  }
`;

export const ScrollButton = styled.button<{ $side: 'start' | 'end' }>`
  position: absolute;
  top: 50%;
  ${({ $side }) => ($side === 'start' ? 'left' : 'right')}: -14px;
  z-index: 2;
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  padding: 0;
  transform: translateY(-50%);
  cursor: pointer;

  ${({ theme: { colors, borderRadius } }) => css`
    border: 1px solid ${colors.outlineVariant};
    border-radius: ${borderRadius.full};
    background: ${colors.surfaceContainerHigh};
    color: ${colors.onSurface};
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
    transition: background-color ${duration.fast} ease;

    &:hover {
      background: ${colors.surfaceContainerHighest};
    }

    &:focus-visible {
      outline: 2px solid ${colors.primary};
      outline-offset: 2px;
    }
  `}

  @media (hover: none) {
    display: none;
  }

  ${APPS_PHONE_MEDIA} {
    display: none;
  }
`;
